import React from 'react';
import '../../styles/MusicalPlayerScreen.css';

export default function MusicalPlayerScreen({ 
  title,
  text,
  image
}) {
  return (
    <div className="content-screen">
      <div className={`content-container`}>
        <div className="content-card">
          
          <div className="content-body">
            
            
            {title && <div
              className={`
                musical-title 
                font-${title?.fontSize ?? "font-md"}
                text-${title?.textAlign ?? "text-left"}
              `}
              dangerouslySetInnerHTML={{__html: title.value}}>
            </div>}

            {text && <div
              className={`
              musical-text font-${text?.fontSize ?? "md"}
              text-${text?.textAlign ?? "text-left"}`
              }
              dangerouslySetInnerHTML={{__html: text.value}}>
            </div>}

            {image && (
              <div className="musical-image">
                <img src={image} alt="" />
              </div>
            )}
            <div class="musical-player-nav"><svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.0656 17.6468C3.94232 20.0521 5.68768 21.9667 7.98198 23.0371C10.2749 24.1075 12.8417 24.2075 15.2088 23.3167C20.0955 21.4775 22.5989 15.9433 20.7888 10.9779C19.9121 8.57261 18.1668 6.658 15.8724 5.58762C13.5795 4.51724 11.0127 4.41719 8.64558 5.30803C7.7203 5.65614 6.86922 6.13995 6.10985 6.74161L10.1468 7.15139L9.79881 10.6969L0.227728 9.72522L1.18404 0L4.67338 0.353589C4.67338 0.353589 4.49264 2.19832 4.31999 3.94711C5.28438 3.21662 6.35533 2.62592 7.5099 2.19146C14.0866 -0.283699 21.42 3.13987 23.856 9.82254C26.2919 16.5052 22.9226 23.9567 16.3459 26.4319C14.9067 26.9732 13.4122 27.2432 11.9218 27.2432C10.1131 27.2432 8.30974 26.8458 6.617 26.0564C3.5296 24.6146 1.17999 22.038 -0.000211716 18.8008L3.0656 17.6468Z" fill="#0F2D4D"></path></svg><svg disabled="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.85926 0V11.5521L23.1935 0.0325241V23.6491L7.85926 12.1279V23.6183H0V0H7.85926Z" fill="#0F2D4D"></path></svg><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="27.892" cy="27.8919" r="27.8919" fill="#FFFBF7"></circle><path d="M37.6217 27.8914L23.0271 36.3175L23.0271 19.4652L37.6217 27.8914Z" fill="#0F2D4D"></path></svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.3343 0V11.5521L0 0.0325241L0 23.6491L15.3343 12.1279V23.6183H23.1935V0L15.3343 0Z" fill="#0F2D4D"></path></svg><svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.5828 17.6468C20.7061 20.0521 18.9608 21.9667 16.6665 23.0371C14.3735 24.1075 11.8067 24.2075 9.4396 23.3167C4.55291 21.4775 2.04954 15.9433 3.85963 10.9779C4.73635 8.57261 6.48168 6.658 8.77599 5.58762C11.0689 4.51724 13.6357 4.41719 16.0029 5.30803C16.9281 5.65614 17.7792 6.13995 18.5386 6.74161L14.5016 7.15139L14.8496 10.6969L24.4207 9.72522L23.4644 0L19.9751 0.353589C19.9751 0.353589 20.1558 2.19832 20.3284 3.94711C19.3641 3.21662 18.2931 2.62592 17.1385 2.19146C10.5618 -0.283699 3.22839 3.13987 0.792462 9.82254C-1.64347 16.5052 1.72584 23.9567 8.30258 26.4319C9.74174 26.9732 11.2362 27.2432 12.7266 27.2432C14.5354 27.2432 16.3387 26.8458 18.0314 26.0564C21.1188 24.6146 23.4685 22.038 24.6486 18.8008L21.5828 17.6468Z" fill="#0F2D4D"></path></svg></div>
          </div>
          
        </div>
      </div>
    </div>
  );
}